<template>
    <div v-if="dataStatus.send2wf == 0" style="background-color:yellow;">
      DRAFT
    </div>
    <div v-else>
      <div v-if="dataStatus.iscomplete == 0">
        <div v-if="dataStatus.isreviewed == 1" style="background-color:khaki;">
          REVIEWED
        </div>
        <div v-else>
          ON PROCESS
        </div>
      </div>
      <div v-else>
        <div v-if="dataStatus.issuccess == 1" style="background-color:#04f681;">
          APPROVED
        </div>
        <div v-else style="background-color:#f86c6b;">           
            REJECTED
          </div>
      </div>
    </div>
</template>


<script>

export default {
  data: () => {
    return {
    };
  },
  props:['dataStatus']
};
</script>
